/** 
 * @type {ProjectContractsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    project_ids: null,
    plan_ids: null,
}
/** 
* @returns {ProjectContractsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/ProjectContractsFilter.js